export function useApiUrl() {
  const config = useRuntimeConfig();
  const bootstrapApiUrl = config.public.apiUrl as string;
  const defaultPublicApiUrl = (config.public.apiPublicUrl || bootstrapApiUrl) as string;
  const publicApiUrl = useState<string>("site-api-url", () => defaultPublicApiUrl);

  const requestApiUrl = computed(() =>
    import.meta.server ? bootstrapApiUrl : publicApiUrl.value
  );

  function customApiUrlForHost(rawHost: string): string | null {
    const host = rawHost.trim().replace(/:\d+$/, "").replace(/\.$/, "").toLowerCase();
    const platformSuffix = (config.public.platformDomainSuffix as string)
      .trim()
      .replace(/^\.+|\.+$/g, "")
      .toLowerCase();

    const isPlatformHost =
      !host ||
      !platformSuffix ||
      host.includes("localhost") ||
      host === platformSuffix ||
      host.endsWith(`.${platformSuffix}`);

    return isPlatformHost ? null : `https://api.${host}`;
  }

  function configureForHost(rawHost: string, customApiReady: boolean) {
    const customApiUrl = customApiUrlForHost(rawHost);
    publicApiUrl.value = customApiReady && customApiUrl
      ? customApiUrl
      : defaultPublicApiUrl;
  }

  return {
    bootstrapApiUrl,
    publicApiUrl,
    requestApiUrl,
    customApiUrlForHost,
    configureForHost,
  };
}
